import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n";
import { sync } from "vuex-router-sync";
import "@/assets/scss/mdc.scss";
import "@/assets/scss/app.scss";
import VueLcs from "@whale/vue-lcs";
import VueNClk from "@whale/vue-nclk";

Vue.use(VueLcs);
Vue.use(VueNClk, {
    g_ssc: "whalespace_developers.home",
    g_pid: "whalespace_developers"
});

Vue.config.productionTip = false;
sync(store, router);
new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount("#app");
